import httpSvc from './HttpSvc'
import { DS_ROUTES } from '@/core/constants'

let userState = null

/**
 * Returns the cached userState,
 * or fetches the state via the API
 * @return {Object} The user's state
 */
export async function getUserState() {
  return userState || fetchUserState()
}

export async function isRegistrationEmailAvailable(email) {
  const resp = await httpSvc.post(DS_ROUTES.user_purple_ribbon_awards_register_email_available, { email })
  return resp.data.email_available
}

export function register(data) {
  clearUserStateCache()
  return httpSvc.post(DS_ROUTES.user_purple_ribbon_awards_register, data)
}

/**
 * Requests the user's state from the API
 * @return {Object} The user's state
 */
async function fetchUserState() {
  const resp = await httpSvc.get(DS_ROUTES.session_logged_in)
  return userState = resp.data
}

/**
 * Clears the userState cache.
 * Sets it back to its original value
 * @return {void}
 */
function clearUserStateCache() {
  userState = null
}
